import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import FadeInSection from '../components/FadeInSection';
import PageBanner from '../components/PageBanner';
import { useCms } from '../context/CmsContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const FAQ = () => {
  const { t, img } = useCms();
  const [faqItems, setFaqItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFAQ = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/faq`);
        setFaqItems(res.data);
      } catch {
        // Silent fail
      } finally {
        setLoading(false);
      }
    };
    fetchFAQ();
  }, []);

  return (
    <div>
      <PageBanner
        image={img('banner.faq')}
        title={t('faq.hero_title', 'Veelgestelde Vragen')}
        subtitle={t('faq.hero_subtitle', 'Hier vind je antwoorden op de meest gestelde vragen over onze service')}
      />

      {/* FAQ Accordion */}
      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        {loading ? (
          <div className="text-center py-20">Loading...</div>
        ) : (
          <FadeInSection>
            <Accordion type="single" collapsible className="space-y-4">
            {faqItems.map((item) => (
              <AccordionItem 
                key={item.id} 
                value={item.id}
                className="bg-white rounded-lg shadow-summer overflow-hidden"
              >
                <AccordionTrigger className="px-6 py-4 text-left font-bold text-lg text-[#13498f] hover:no-underline hover:bg-[#F5E6D3] transition-colors">
                  {item.vraag}
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-4 text-gray-700 text-base leading-relaxed">
                  {item.antwoord}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
          </FadeInSection>
        )}
      </section>

      {/* CTA */}
      <section className="bg-[#F5E6D3] py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6 text-[#13498f]">
            Nog Vragen?
          </h2>
          <p className="text-lg text-gray-700 mb-8">
            Neem gerust contact met ons op. We helpen je graag verder!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="https://wa.me/31612345678" className="btn-primary">
              WhatsApp Ons
            </a>
            <a href="/contact" className="btn-secondary">
              Contactpagina
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;